export const colors = {
  primary:
    'border-neutral-50 hover:border-primary-700 ' +
    'focus:border-primary-700 focus:ring-primary-50 focus:shadow-primary' +
    'disabled:hover:border-neutral-50',

  secondary:
    'border-neutral-50 hover:border-secondary-accent ' +
    'focus:border-secondary-accent focus:ring-secondary-50 focus:shadow-secondary' +
    'disabled:hover:border-neutral-50',

  neutral:
    'border-neutral-50 hover:border-base-primary ' +
    'focus:border-base-primary focus:ring-neutral-200 focus:shadow-sm' +
    'disabled:hover:border-neutral-50',

  warning:
    'border-warning-400 hover:border-warning-400 ' +
    'focus:border-warning-400 focus:ring-warning-200 focus:shadow-warning' +
    'disabled:hover:border-neutral-50',

  error:
    'border-secondary-accent hover:border-secondary-accent ' +
    'focus:border-secondary-accent focus:ring-secondary-50 focus:shadow-secondary' +
    'disabled:hover:border-neutral-50',
} as const;
